export type BillingCycle = "monthly" | "annual";
export const PLAN_INQUIRY_NOTE =
  "Ask about a plan or request a demo. We’ll confirm availability, setup, timing, and payment terms before you commit. Sending an inquiry does not start a subscription.";
// Published live offers verified against chleb.ai and clean source 928abf0.
// Annual totals are the actual published charges, not a rounded discount.
export const PLANS = [
  {
    id: "crm",
    name: "CRM",
    intro: "Every lead lands in one pipeline, not six sticky notes.",
    monthly: 297,
    annual: 3029,
    monthlyUrl: "/contact?plan=crm&billing=monthly#contact",
    annualUrl: "/contact?plan=crm&billing=annual#contact",
    features: [
      "Branded CRM with pipelines, deal stages, and tasks",
      "Appointment booking calendar",
      "Email follow-up sequences",
      "Contact tagging and segmentation",
      "Review automation and reporting",
      "One landing page, built by our team",
    ],
  },
  {
    id: "receptionist",
    name: "AI Receptionist + Chatbot",
    intro: "Answers the phone when your team is on a job.",
    monthly: 899,
    annual: 9170,
    monthlyUrl: "/contact?plan=receptionist&billing=monthly#contact",
    annualUrl: "/contact?plan=receptionist&billing=annual#contact",
    features: [
      "AI call answering, 24/7",
      "Caller qualification and lead capture",
      "Appointment booking into your calendar",
      "Website chatbot with booking",
      "Call recordings and transcripts",
      "Booking calendar included",
    ],
  },
  {
    id: "bundle",
    name: "Front Office Bundle",
    intro: "The receptionist and the CRM, running as one system.",
    monthly: 997,
    annual: 10169,
    monthlyUrl: "/contact?plan=bundle&billing=monthly#contact",
    annualUrl: "/contact?plan=bundle&billing=annual#contact",
    features: [
      "Everything in CRM and AI Receptionist + Chatbot",
      "CRM connected to your live call data",
      "Callers become tracked contacts automatically",
      "One place for calls, leads, and bookings",
      "Priority onboarding",
      "A dedicated account contact",
    ],
  },
] as const;
export function planInquiryMessage(params: URLSearchParams) {
  const plan = PLANS.find((item) => item.id === params.get("plan"));
  const billing = params.get("billing");
  if (!plan || (billing !== "monthly" && billing !== "annual")) return "";
  return `I’d like to discuss the ${plan.name} plan with ${billing} billing. Please confirm availability, setup, timing, and payment terms.`;
}
export const money = (value: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
export const checkout = (id: string, billing: BillingCycle) => {
  const p = PLANS.find((p) => p.id === id);
  return p ? (billing === "annual" ? p.annualUrl : p.monthlyUrl) : undefined;
};

// The comparison matrix. One row set for all three cards, in the same order,
// so the rows line up across the columns and a reader can compare down the
// page. Columns follow the order of PLANS in commerce.ts: CRM, AI Receptionist
// + Chatbot, Front Office Bundle. Prices and checkout links never live here.
export const PLAN_ROWS: readonly (readonly [string, boolean, boolean, boolean])[] = [
  ["Missed-call recovery", true, true, true],
  ["Appointment booking calendar", true, true, true],
  ["Pipelines, deal stages, and tasks", true, false, true],
  ["Email follow-up sequences", true, false, true],
  ["Contact tagging and segmentation", true, false, true],
  ["Review automation and reporting", true, false, true],
  ["One landing page, built by our team", true, false, true],
  ["AI call answering, around the clock", false, true, true],
  ["Caller qualification and lead capture", false, true, true],
  ["Website chatbot with booking", false, true, true],
  ["Call recordings and transcripts", false, true, true],
  ["CRM connected to your live call data", false, false, true],
  ["Callers become tracked contacts", false, false, true],
  ["Priority onboarding and a dedicated contact", false, false, true],
];
